<style lang="scss" scoped>
.PreviewHome {
  width: 375px;
  height: 705px;
  position: relative;
  box-sizing: border-box;

  .pa {
    position: absolute;
  }

  .back {
    width: 100%;
    height: 100%;
    z-index: 2;
    position: relative;
  }
  .box {
    padding: 125px 25px 0 25px;
    width: 100%;
    height: 100%;
  }
  .headBack {
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    img {
      width: 100%;
    }
  }
  .userInfo {
    top: 92px;
    left: 88px;
    z-index: 2;
    color: #fff;
    .name {
      font-size: 16px;
      font-weight: 600;
    }
    .store {
      font-size: 14px;
    }
  }
  .navs {
    top: 186px;
    left: 0;
    width: 100%;
    height: 80px;
    background: #f7f7f7;
    display: flex;
    z-index: 2;
    text-align: center;
    padding: 0 10px;
    padding-top: 20px;
    border-radius: 20px;
    .item {
      flex: 1;
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
  .topBack {
    top: 370px;
    left: 26px;
    z-index: 2;
    width: 327px;
    height: 74px;
    border-radius: 5px;
    overflow: hidden;
    img {
      width: 100%;
      height: 74px;
    }
    .desc {
      position: absolute;
      left: 20px;
      line-height: 76px;
      color: #fff;
    }
  }
}
</style>
<template>
  <div class="PreviewHome">
    <img
      class="back"
      :src="require('@/assets/img/guideShopshelf/home1.png')"
      alt=""
    >
    <div class="headBack pa">
      <img
        :src="homeConfig.headBack"
        alt=""
      >
    </div>
    <div class="userInfo pa">
      <div
        class="name"
        :style="{ 'color': homeConfig.primaryColor }"
      >
        导购姓名
      </div>
      <div
        class="store"
        :style="{ 'color': homeConfig.primaryColor }"
      >
        导购门店
      </div>
    </div>
    <div class="navs pa">
      <div
        v-for="(item, index) in homeConfig.navs"
        :key="index"
        class="item"
      >
        <img
          v-if="item.icon || item.defaultMenusIcon"
          :src="item.icon || item.defaultMenusIcon"
          class=""
          alt=""
        >
        <i
          v-else
          class="el-icon-s-tools"
        />
        <div>
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="topBack pa">
      <div class="desc">
        我的排名
      </div>
      <img
        :src="homeConfig.topBack"
        alt=""
      >
    </div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'PreviewHome',
  props: {
    homeConfig: {
      type: Object,
      default: () => {
        return {
          headBack:
            'https://bbctest.aixue7.com/image/1/2021/04/15/5ea264bc6ae13cb332a258504c5ae0a2U08DzEgvQ7FxFClf7rdjob6TkDn6VygH',
          text: '',
          tabBar: '',
          topBack: '',
          navs: [],
          primaryColor: '#fff'
        }
      }
    }
  },
  data () {
    return {
      showImgPicker: false
    }
  },
  created () {},
  methods: {}
}
</script>
